import styled from "styled-components";

export const SectionWrap = styled.section `
    position: relative;
`;